const ja = {
  action: {
    save: '保存',
    close: '閉じる',
    cancel: 'キャンセル',
    submit: '送信',
  },
  vehicles: {
    title: '車両一覧',
  },
  vehicle: {
    title: '車両詳細',
  },
  transfer: {
    title: '車両移管',
    dialog: {
      create: '移管を作成',
      base_title: '車両移管リクエスト管理画面',
    },
    status: {
      requester: {
        initial: 'リクエスト作成済み',
        pending_approval: '承認依頼申請済み',
        approved: '承認済み',
        rejected: '却下',
        cancelled: 'キャンセル済み',
        preparing: '移管準備中',
        preparing_failed: '移管準備失敗',
        transferring: '移管実行中',
        post_transferring: '移管後処理中',
        post_transferring_failed: '移管後処理失敗',
        rolling_back: '移管失敗: 復旧中',
        rolling_back_failed: '移管失敗: 復旧失敗',
        rolling_back_succeeded: '移管失敗: 復旧成功',
        completed: '移管完了',
      },
      reviewer: {
        initial: 'リクエスト作成済み',
        pending_approval: '承認依頼あり',
        approved: '承認済み',
        rejected: '却下',
        cancelled: 'キャンセル済み',
        preparing: '移管準備中',
        preparing_failed: '移管準備失敗',
        transferring: '移管実行中',
        post_transferring: '移管後処理中',
        post_transferring_failed: '移管後処理失敗',
        rolling_back: '移管失敗: 復旧中',
        rolling_back_failed: '移管失敗: 復旧失敗',
        rolling_back_succeeded: '移管失敗: 復旧成功',
        completed: '移管完了',
      },
    },
  },
} as const;

export default ja;
